// ✅ PaymentRequestPage.jsx (Full Updated Code)

import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://api.quote.softvolute.in";

const phonepeLink = "https://pmny.in/yourcustomlink"; // Replace with actual

const PaymentRequestPage = () => {
  const { projectId } = useParams();
  const [finalAmount, setFinalAmount] = useState(0);
  const [projectName, setProjectName] = useState("");
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientPhone, setClientPhone] = useState("");
  const [customAmount, setCustomAmount] = useState("");
  const [payments, setPayments] = useState([]);

  const stages = ["10%", "50%", "40%", "Custom"];

  useEffect(() => {
    if (!projectId) return;

    axios
      .get(`${BASE_URL}/api/quotes/by-project-id/${projectId}`)
      .then((res) => {
        const quote = res.data;
        setFinalAmount(quote.finalAmount || 0);
        setProjectName(quote.projectName || "");
        setClientName(quote.clientName || "");

        return axios.get(
          `${BASE_URL}/api/client-details/${encodeURIComponent(
            quote.projectName,
          )}`,
        );
      })
      .then((res) => {
        const details = res.data;
        setClientEmail(details.email || "");
        setClientPhone(details.phoneNumber || "");
      })
      .catch((err) => {
        console.error("❌ Error fetching quote/client detail:", err.message);
        alert("Failed to fetch required details.");
      });

    axios
      .get(`${BASE_URL}/api/payments/project/${projectId}`)
      .then((res) => setPayments(res.data))
      .catch((err) => console.error("❌ Failed to fetch payments:", err));
  }, [projectId]);

  const getAmount = (stage) => {
    if (stage === "Custom") return parseFloat(customAmount || 0);
    const percent = parseFloat(stage);
    return ((finalAmount * percent) / 100).toFixed(2);
  };

  const getStatusForStage = (stage) => {
    const payment = payments.find((p) => p.stage === stage);
    return payment?.status === "Received" ? "✅ Received" : "❌ Pending";
  };

  const sendMail = async (stage, amount) => {
    if (!clientEmail) return alert("❌ Client email not found!");

    try {
      const subject = `Payment Request for ${stage} - Softvolute Buildcon LLP`;
      const message = `
        <p>Dear ${clientName},</p>
        <p>This is a payment request for your project <b>${projectName}</b>.</p>
        <p><b>Stage:</b> ${stage}</p>
        <p><b>Amount:</b> ₹${amount}</p>
        <p>Please pay via the link: <a href="${phonepeLink}" target="_blank">${phonepeLink}</a></p>
        <br/>
        <p>Regards,<br/>Softvolute Buildcon LLP</p>
      `;

      const userEmail = localStorage.getItem("userEmail")?.trim();
      const ccEmails = `manan.sheth@partner.designcafe,finanacesvbllp@gmail.com$${
        userEmail ? `,${userEmail}` : ""
      }`;

      const formData = new FormData();
      formData.append("toEmail", clientEmail);
      formData.append("ccEmail", ccEmails);
      formData.append("subject", subject);
      formData.append("message", message);

      await axios.post(`${BASE_URL}/api/email/send-mail`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("✅ Email sent successfully!");
    } catch (error) {
      console.error("❌ Failed to send email:", error.message);
      alert("❌ Failed to send email");
    }
  };

  const sendWhatsApp = (stage, amount) => {
    if (!clientPhone) return alert("❌ Client phone number not found!");

    const message = `📢 Payment Request from Softvolute Buildcon LLP\n\n👤 Client: ${clientName}\n📁 Project: ${projectName}\n💰 Stage: ${stage}\n💵 Amount: ₹${amount}\n\n🔗 Pay Now: ${phonepeLink}`;
    const url = `https://wa.me/91${clientPhone}?text=${encodeURIComponent(
      message,
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div style={{ padding: "30px" }}>
      <h2 style={{ textAlign: "center" }}>📩 Payment Request</h2>
      <h3 style={{ color: "#343a76" }}>
        Total Quote Amount:{" "}
        <span style={{ color: "green" }}>
          ₹{parseFloat(finalAmount).toLocaleString("en-IN")}
        </span>
      </h3>

      <table
        style={{ width: "100%", marginTop: "20px", borderCollapse: "collapse" }}
      >
        <thead>
          <tr style={{ backgroundColor: "#343a76", color: "white" }}>
            <th style={{ padding: "10px", border: "1px solid #ccc" }}>Stage</th>
            <th style={{ padding: "10px", border: "1px solid #ccc" }}>
              Amount
            </th>
            <th style={{ padding: "10px", border: "1px solid #ccc" }}>Send</th>
          </tr>
        </thead>
        <tbody>
          {stages.map((stage, index) => {
            const amount = getAmount(stage);
            return (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#f9f9f9" : "white",
                }}
              >
                <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                  {stage}
                </td>
                <td style={{ padding: "10px", border: "1px solid #ccc" }}>
                  {stage === "Custom" ? (
                    <input
                      type="number"
                      value={customAmount}
                      onChange={(e) => setCustomAmount(e.target.value)}
                      placeholder="Enter custom amount"
                      style={{ padding: "5px", width: "120px" }}
                    />
                  ) : (
                    <>
                      ₹{parseFloat(amount).toLocaleString("en-IN")}
                      <span
                        style={{
                          marginLeft: "10px",
                          fontWeight: "bold",
                          color:
                            getStatusForStage(stage) === "✅ Received"
                              ? "green"
                              : "red",
                        }}
                      >
                        {getStatusForStage(stage)}
                      </span>
                    </>
                  )}
                </td>
                <td
                  style={{
                    padding: "10px",
                    border: "1px solid #ccc",
                    textAlign: "center",
                  }}
                >
                  <button
                    onClick={() => sendMail(stage, amount)}
                    style={{
                      padding: "6px 10px",
                      margin: "0 4px",
                      backgroundColor: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    📧 Mail
                  </button>
                  <button
                    onClick={() => sendWhatsApp(stage, amount)}
                    style={{
                      padding: "6px 10px",
                      margin: "0 4px",
                      backgroundColor: "#28a745",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    📲 WhatsApp
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentRequestPage;
